module.exports = __webpack_public_path__ + "img/huizhoujingji.54c6c014.png";